export default {
  props: {
    all_text: {
      type: Object,
      default: () => {}
    }
  }
};